/**
 * ROOTÉ motion pack.
 * - Adds subtle "reveal on scroll" to sections and product grid items
 * - Respects prefers-reduced-motion
 */

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function markVisibleImmediately(elements) {
  elements.forEach((el) => el.classList.add('roote-reveal', 'is-visible'));
}

function setupReveal() {
  const sections = Array.from(document.querySelectorAll('main .shopify-section'));
  const productGridItems = Array.from(document.querySelectorAll('.product-grid .product-grid__item'));

  const targets = [...sections, ...productGridItems].filter((el) => el instanceof HTMLElement);
  if (!targets.length) return;

  // Apply base class and stagger delay for product cards
  targets.forEach((el) => {
    el.classList.add('roote-reveal');
  });

  productGridItems.forEach((el, index) => {
    if (!(el instanceof HTMLElement)) return;
    const delay = Math.min(index * 55, 420);
    el.style.setProperty('--reveal-delay', `${delay}ms`);
  });

  if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
    markVisibleImmediately(targets);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (el instanceof HTMLElement) {
          el.classList.add('is-visible');
        }
        observer.unobserve(el);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  targets.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupReveal, { once: true });
} else {
  setupReveal();
}

